import { FC } from 'react';
import en_US from './en-US';
import zh_CN from './zh-CN';
import ko_KR from './ko-KR';
import vi_VN from './vi-VN';
import { FormattedMessage, MessageDescriptor, useIntl } from 'react-intl';

export const localeConfig = {
  zh_CN: zh_CN,
  en_US: en_US,
  ko_KR: ko_KR,
  vi_VN: vi_VN
};

type Id = keyof typeof vi_VN;

interface Props extends MessageDescriptor {
  id: Id;
  values?: any;
}

export const LocaleFormatter: FC<Props> = ({ ...props }) => {
  const notChildProps = { ...props, children: undefined };

  return <FormattedMessage {...notChildProps} id={props.id} />;
};

type FormatMessageProps = (descriptor: Props, value?: any) => string;

export const useLocale = () => {
  const { formatMessage: _formatMessage, ...rest } = useIntl();
  const formatMessage: FormatMessageProps = _formatMessage;

  return {
    ...rest,
    formatMessage
  };
};
